import {
    createFeatureSelector,
    createSelector
} from '@ngrx/store';
import {AuthZState} from '../reducers/authz.reducer';

export const selectAuthZ = createFeatureSelector<AuthZState>('authZ');

export const getStructuresList = createSelector(
    selectAuthZ,
    state => state.autorizedStructuresList
);

export const getStructureSelected = createSelector(
    selectAuthZ,
    state => state.autorizedStructureSelected
);

export const isStructureSelected = createSelector(
    selectAuthZ,
    state => !!state.autorizedStructureSelected
);

export const getAutorizedModulesList = createSelector(
    selectAuthZ,
    state => state.autorizedModules
);

export const isModuleAccessAuthorized = createSelector(
    selectAuthZ,
    state => state.hasAccessToRequestingModule
);

export const isModuleAccessAuthorizedSuccessed = createSelector(
    selectAuthZ,
    state => state.autorizedModulesLoading.isSuccessed()
);

export const getTraitementsList = createSelector(
    selectAuthZ,
    state => state.traitementsListForRequestingModule
);

export const getUserPerimetres = createSelector(
  selectAuthZ,
  state => state.perimetresListForUser
);

export const getTraitementsAuthorizedByStructure = createSelector(
    getTraitementsList,
    (traitementsList: Array<any>): Array<string> => traitementsList
);

export const hasTraitement = createSelector(
  getTraitementsList,
  (traitementsList: string[], traitement: string): boolean => {
    if (traitement == null) {
      return true;
    }
    const traitementUpperCase = traitement.toUpperCase();
    return traitementsList.some(tr => traitementUpperCase.match(tr));
  }
);

export const hasPerimetre = createSelector(
  getUserPerimetres,
  (userPerimetres: string[], perimetreToTest: string): boolean => {
    if (perimetreToTest == null) {
      return true;
    }
    const perimetreToTestUpperCase = perimetreToTest.toUpperCase();
    return userPerimetres.some(userPerimetre => perimetreToTestUpperCase.match(userPerimetre));
  }
);

export const hasAnyTraitement = createSelector(
  getTraitementsList,
  (traitementsList: string[], traitements: string[]): boolean => {
    if (!traitements?.length) {
      return true;
    }
    const traitementsUpperCase = traitements.map(t => t.toUpperCase());
    return traitementsList?.some(tFromList => traitementsUpperCase.some(t => t.match(tFromList))) ?? false;
  }
);

export const hasAnyPerimetre = createSelector(
  getUserPerimetres,
  (userPerimetres: string[], perimetresListToTest: string[]): boolean => {
    if (!perimetresListToTest?.length) {
      return true;
    }
    const perimetresListToTestUpperCase = perimetresListToTest.map(pToTest => pToTest.toUpperCase());
    return userPerimetres?.some(userPerimetre => perimetresListToTestUpperCase.some(pToTest => pToTest.match(userPerimetre))) ?? false;
  }
);


export const hasAllTraitement = createSelector(
  getTraitementsList,
  (traitementsList: string[], traitements: string[]): boolean => {
    if (!traitements?.length) {
      return true;
    }
    if (!traitementsList) {
      return false;
    }
    const traitementsUpperCase = traitements.map(t => t.toUpperCase());
    return !traitementsUpperCase.some(t => !traitementsList.some(traitement => t.match(traitement)));
  }
);

export const hasAllPerimetre = createSelector(
  getUserPerimetres,
  (userPerimetres: string[], perimetresListToTest: string[]): boolean => {
    if (!perimetresListToTest?.length) {
      return true;
    }
    if (!userPerimetres) {
      return false;
    }
    const perimetresListToTestUpperCase = perimetresListToTest.map(pToTest => pToTest.toUpperCase());
    return !perimetresListToTestUpperCase.some(pToTest => !userPerimetres.some(userPerimetre => pToTest.match(userPerimetre)));
  }
);
